import React, { useState } from "react";
import { useDispatch } from "react-redux";
import { downloadFormApi } from "../../apis/hearnuform.api";
import { callApiAction } from "../../store/actions/commonAction";
import HearNUFormListUI from "./HearNUFormListUI";
import fileDownload from "js-file-download";
import { callSnackBar } from "../../store/actions/snackbarAction";
import { SNACK_BAR_VARIETNS } from "../../utils/constants";

const HearNUFormListController = () => {
  const [loading, setLoading] = useState(false);
  const dispatch = useDispatch();

  const onDownloadCsv = () => {
    setLoading(true);
    dispatch(
      callApiAction(
        async () => await downloadFormApi({ csv: true }),
        (response) => {
          fileDownload(response, "inventory_Format.csv");
          setLoading(false);
          dispatch(
            callSnackBar("Downloaded Successfully", SNACK_BAR_VARIETNS.success)
          );
        },
        (err) => {
          dispatch(callSnackBar(err, SNACK_BAR_VARIETNS.error));
          setLoading(false);
        },
        true
      )
    );
  };

  return (
    <>
      <HearNUFormListUI loading={loading} onDownloadCsv={onDownloadCsv} />
    </>
  );
};

export default HearNUFormListController;
